/**
 * @author Harish.R <harish.r@314ecorp.com>
 * @description Details Renderer for cards
 */
import { JSX } from 'react';
import _ from 'lodash';

import { EMPTY_VALUE } from '@veritable/common/constants';

/**
 * pickValueToRender
 */
const pickValueToRender = (value: AnyType, render: (value: AnyType, data?: AnyType) => AnyType, data?: AnyType): React.ReactNode => {
	if (_.includes(['', null, undefined, {}, []], value)) {
		return EMPTY_VALUE;
	}
	if (_.isFunction(render)) {
		return render(value, data);
	}
	return value;
};

const getSupportEmail = ({ email, label }: { email: string; label?: string }): JSX.Element => {
	return (
		<a href={`mailto:${email}`}>
			<u className='mx-1.5'>{label ?? email}</u>
		</a>
	);
};

export { pickValueToRender, getSupportEmail };
